import React from "react";

import Slider from "rc-slider";

import styles from "./style.module.css";

const colorsTwo = [
  "#D57DF5",
  "#7E69D7",
  "#2F80ED",
  "#56CCF2",
  "#52FFD3",
  "#5BCF74",
  "#96E964",
  "#FFCF71",
  "#F97255",
  "#FF84CE"
];

export default class ImpactSlider extends React.Component {
  allEqual(arr) {
    return arr.every((v) => v === arr[0]);
  }

  render() {
    const { impacts, label, currentImpact, showLabels, drilldownValue, updateDrilldownValue } = this.props;

    let marks = {};
    let dataMap = {};
    impacts.forEach((d, i) => {
      marks[Number(d.value)] = (
        <div
          className={styles.dotHolder}
          style={{
            background: d.color
          }}
          //  onClick={() => updateDrilldownValue(d.runId, d.value)}
        ></div>
      );

      dataMap[Number(d.value)] = d;
    });

    return (
      <div className={styles.impactSlider}>
        {this.allEqual(impacts.map((i) => i.value)) ? (
          <div style={{ fontWeight: "initial" }}>{"Equal across all segments"}</div>
        ) : (
          <div className={styles.sliderHolder}>
            <Slider
              min={Math.min.apply(
                Math,
                impacts.map((i) => Number(i.value))
              )}
              max={Math.max.apply(
                Math,
                impacts.map((i) => Number(i.value))
              )}
              onChange={(e) => {
                updateDrilldownValue(dataMap[currentImpact].runId, e);
              }}
              marks={marks}
              included={false}
              value={Number(currentImpact)}
              step={0.5}
              handleStyle={{
                background: "transparent",
                borderColor: "white",
                boxShadow: "0px 0px 6px 1px rgba(81, 47, 119, 0.35)",
                zIndex: 100,
                pointer: "cursor !important"
              }}
              /*
              onAfterChange={(e) =>{
                updateDrilldownValue(
                  dataMap[e].runId,
                  e
                )
              }}
              */
            />
          </div>
        )}
      </div>
    );
  }
}
